export default __webpack_public_path__ + "static/media/one.8ffedb1a.png";